export enum DelegationType {
    InAppNotifications = 1
}

export const DelegationTypeOptions = [{ key: DelegationType.InAppNotifications, value: 'Notifications' }];
